/**
 * Single source of truth for phone country codes.
 *
 * Every mobile-number field in the app (leads, brokers, candidates, profile)
 * reads from here — previously each page kept its own 5-entry copy.
 *
 * Flags are derived from the ISO-3166 alpha-2 code (regional indicator letters)
 * so there is no emoji to keep in sync per country.
 */

// [ISO2, country name, dial code]
const RAW = [
  ['AF', 'Afghanistan', '+93'],
  ['AL', 'Albania', '+355'],
  ['DZ', 'Algeria', '+213'],
  ['AD', 'Andorra', '+376'],
  ['AO', 'Angola', '+244'],
  ['AI', 'Anguilla', '+1264'],
  ['AG', 'Antigua and Barbuda', '+1268'],
  ['AR', 'Argentina', '+54'],
  ['AM', 'Armenia', '+374'],
  ['AW', 'Aruba', '+297'],
  ['AU', 'Australia', '+61'],
  ['AT', 'Austria', '+43'],
  ['AZ', 'Azerbaijan', '+994'],
  ['BS', 'Bahamas', '+1242'],
  ['BH', 'Bahrain', '+973'],
  ['BD', 'Bangladesh', '+880'],
  ['BB', 'Barbados', '+1246'],
  ['BY', 'Belarus', '+375'],
  ['BE', 'Belgium', '+32'],
  ['BZ', 'Belize', '+501'],
  ['BJ', 'Benin', '+229'],
  ['BM', 'Bermuda', '+1441'],
  ['BT', 'Bhutan', '+975'],
  ['BO', 'Bolivia', '+591'],
  ['BA', 'Bosnia and Herzegovina', '+387'],
  ['BW', 'Botswana', '+267'],
  ['BR', 'Brazil', '+55'],
  ['VG', 'British Virgin Islands', '+1284'],
  ['BN', 'Brunei', '+673'],
  ['BG', 'Bulgaria', '+359'],
  ['BF', 'Burkina Faso', '+226'],
  ['BI', 'Burundi', '+257'],
  ['KH', 'Cambodia', '+855'],
  ['CM', 'Cameroon', '+237'],
  ['CA', 'Canada', '+1'],
  ['CV', 'Cape Verde', '+238'],
  ['KY', 'Cayman Islands', '+1345'],
  ['CF', 'Central African Republic', '+236'],
  ['TD', 'Chad', '+235'],
  ['CL', 'Chile', '+56'],
  ['CN', 'China', '+86'],
  ['CO', 'Colombia', '+57'],
  ['KM', 'Comoros', '+269'],
  ['CG', 'Congo', '+242'],
  ['CD', 'Congo (DRC)', '+243'],
  ['CK', 'Cook Islands', '+682'],
  ['CR', 'Costa Rica', '+506'],
  ['CI', "Cote d'Ivoire", '+225'],
  ['HR', 'Croatia', '+385'],
  ['CU', 'Cuba', '+53'],
  ['CW', 'Curacao', '+599'],
  ['CY', 'Cyprus', '+357'],
  ['CZ', 'Czechia', '+420'],
  ['DK', 'Denmark', '+45'],
  ['DJ', 'Djibouti', '+253'],
  ['DM', 'Dominica', '+1767'],
  ['DO', 'Dominican Republic', '+1809'],
  ['EC', 'Ecuador', '+593'],
  ['EG', 'Egypt', '+20'],
  ['SV', 'El Salvador', '+503'],
  ['GQ', 'Equatorial Guinea', '+240'],
  ['ER', 'Eritrea', '+291'],
  ['EE', 'Estonia', '+372'],
  ['SZ', 'Eswatini', '+268'],
  ['ET', 'Ethiopia', '+251'],
  ['FJ', 'Fiji', '+679'],
  ['FI', 'Finland', '+358'],
  ['FR', 'France', '+33'],
  ['GF', 'French Guiana', '+594'],
  ['PF', 'French Polynesia', '+689'],
  ['GA', 'Gabon', '+241'],
  ['GM', 'Gambia', '+220'],
  ['GE', 'Georgia', '+995'],
  ['DE', 'Germany', '+49'],
  ['GH', 'Ghana', '+233'],
  ['GI', 'Gibraltar', '+350'],
  ['GR', 'Greece', '+30'],
  ['GL', 'Greenland', '+299'],
  ['GD', 'Grenada', '+1473'],
  ['GP', 'Guadeloupe', '+590'],
  ['GU', 'Guam', '+1671'],
  ['GT', 'Guatemala', '+502'],
  ['GN', 'Guinea', '+224'],
  ['GW', 'Guinea-Bissau', '+245'],
  ['GY', 'Guyana', '+592'],
  ['HT', 'Haiti', '+509'],
  ['HN', 'Honduras', '+504'],
  ['HK', 'Hong Kong', '+852'],
  ['HU', 'Hungary', '+36'],
  ['IS', 'Iceland', '+354'],
  ['IN', 'India', '+91'],
  ['ID', 'Indonesia', '+62'],
  ['IR', 'Iran', '+98'],
  ['IQ', 'Iraq', '+964'],
  ['IE', 'Ireland', '+353'],
  ['IL', 'Israel', '+972'],
  ['IT', 'Italy', '+39'],
  ['JM', 'Jamaica', '+1876'],
  ['JP', 'Japan', '+81'],
  ['JO', 'Jordan', '+962'],
  ['KZ', 'Kazakhstan', '+7'],
  ['KE', 'Kenya', '+254'],
  ['KI', 'Kiribati', '+686'],
  ['KW', 'Kuwait', '+965'],
  ['KG', 'Kyrgyzstan', '+996'],
  ['LA', 'Laos', '+856'],
  ['LV', 'Latvia', '+371'],
  ['LB', 'Lebanon', '+961'],
  ['LS', 'Lesotho', '+266'],
  ['LR', 'Liberia', '+231'],
  ['LY', 'Libya', '+218'],
  ['LI', 'Liechtenstein', '+423'],
  ['LT', 'Lithuania', '+370'],
  ['LU', 'Luxembourg', '+352'],
  ['MO', 'Macau', '+853'],
  ['MG', 'Madagascar', '+261'],
  ['MW', 'Malawi', '+265'],
  ['MY', 'Malaysia', '+60'],
  ['MV', 'Maldives', '+960'],
  ['ML', 'Mali', '+223'],
  ['MT', 'Malta', '+356'],
  ['MH', 'Marshall Islands', '+692'],
  ['MQ', 'Martinique', '+596'],
  ['MR', 'Mauritania', '+222'],
  ['MU', 'Mauritius', '+230'],
  ['MX', 'Mexico', '+52'],
  ['FM', 'Micronesia', '+691'],
  ['MD', 'Moldova', '+373'],
  ['MC', 'Monaco', '+377'],
  ['MN', 'Mongolia', '+976'],
  ['ME', 'Montenegro', '+382'],
  ['MS', 'Montserrat', '+1664'],
  ['MA', 'Morocco', '+212'],
  ['MZ', 'Mozambique', '+258'],
  ['MM', 'Myanmar', '+95'],
  ['NA', 'Namibia', '+264'],
  ['NR', 'Nauru', '+674'],
  ['NP', 'Nepal', '+977'],
  ['NL', 'Netherlands', '+31'],
  ['NC', 'New Caledonia', '+687'],
  ['NZ', 'New Zealand', '+64'],
  ['NI', 'Nicaragua', '+505'],
  ['NE', 'Niger', '+227'],
  ['NG', 'Nigeria', '+234'],
  ['NU', 'Niue', '+683'],
  ['KP', 'North Korea', '+850'],
  ['MK', 'North Macedonia', '+389'],
  ['NO', 'Norway', '+47'],
  ['OM', 'Oman', '+968'],
  ['PK', 'Pakistan', '+92'],
  ['PW', 'Palau', '+680'],
  ['PS', 'Palestine', '+970'],
  ['PA', 'Panama', '+507'],
  ['PG', 'Papua New Guinea', '+675'],
  ['PY', 'Paraguay', '+595'],
  ['PE', 'Peru', '+51'],
  ['PH', 'Philippines', '+63'],
  ['PL', 'Poland', '+48'],
  ['PT', 'Portugal', '+351'],
  ['PR', 'Puerto Rico', '+1787'],
  ['QA', 'Qatar', '+974'],
  ['RE', 'Reunion', '+262'],
  ['RO', 'Romania', '+40'],
  ['RU', 'Russia', '+7'],
  ['RW', 'Rwanda', '+250'],
  ['KN', 'Saint Kitts and Nevis', '+1869'],
  ['LC', 'Saint Lucia', '+1758'],
  ['VC', 'Saint Vincent and the Grenadines', '+1784'],
  ['WS', 'Samoa', '+685'],
  ['SM', 'San Marino', '+378'],
  ['ST', 'Sao Tome and Principe', '+239'],
  ['SA', 'Saudi Arabia', '+966'],
  ['SN', 'Senegal', '+221'],
  ['RS', 'Serbia', '+381'],
  ['SC', 'Seychelles', '+248'],
  ['SL', 'Sierra Leone', '+232'],
  ['SG', 'Singapore', '+65'],
  ['SK', 'Slovakia', '+421'],
  ['SI', 'Slovenia', '+386'],
  ['SB', 'Solomon Islands', '+677'],
  ['SO', 'Somalia', '+252'],
  ['ZA', 'South Africa', '+27'],
  ['KR', 'South Korea', '+82'],
  ['SS', 'South Sudan', '+211'],
  ['ES', 'Spain', '+34'],
  ['LK', 'Sri Lanka', '+94'],
  ['SD', 'Sudan', '+249'],
  ['SR', 'Suriname', '+597'],
  ['SE', 'Sweden', '+46'],
  ['CH', 'Switzerland', '+41'],
  ['SY', 'Syria', '+963'],
  ['TW', 'Taiwan', '+886'],
  ['TJ', 'Tajikistan', '+992'],
  ['TZ', 'Tanzania', '+255'],
  ['TH', 'Thailand', '+66'],
  ['TL', 'Timor-Leste', '+670'],
  ['TG', 'Togo', '+228'],
  ['TO', 'Tonga', '+676'],
  ['TT', 'Trinidad and Tobago', '+1868'],
  ['TN', 'Tunisia', '+216'],
  ['TR', 'Turkey', '+90'],
  ['TM', 'Turkmenistan', '+993'],
  ['TC', 'Turks and Caicos Islands', '+1649'],
  ['TV', 'Tuvalu', '+688'],
  ['UG', 'Uganda', '+256'],
  ['UA', 'Ukraine', '+380'],
  ['AE', 'United Arab Emirates', '+971'],
  ['GB', 'United Kingdom', '+44'],
  ['US', 'United States', '+1'],
  ['UY', 'Uruguay', '+598'],
  ['UZ', 'Uzbekistan', '+998'],
  ['VU', 'Vanuatu', '+678'],
  ['VA', 'Vatican City', '+379'],
  ['VE', 'Venezuela', '+58'],
  ['VN', 'Vietnam', '+84'],
  ['VI', 'U.S. Virgin Islands', '+1340'],
  ['YE', 'Yemen', '+967'],
  ['ZM', 'Zambia', '+260'],
  ['ZW', 'Zimbabwe', '+263'],
];

// Extra search terms per country — major cities and alternate names, so
// searching "muscat", "dubai" or "emirates" finds the right dial code.
// Gulf markets are covered in depth since that is where this CRM is used.
const ALIASES = {
  AE: ['uae', 'emirates', 'dubai', 'abu dhabi', 'abudhabi', 'sharjah', 'ajman',
       'ras al khaimah', 'rak', 'fujairah', 'umm al quwain', 'al ain', 'deira', 'jebel ali'],
  SA: ['ksa', 'saudi', 'riyadh', 'jeddah', 'jiddah', 'dammam', 'khobar', 'al khobar',
       'mecca', 'makkah', 'medina', 'madinah', 'jubail', 'taif', 'tabuk', 'abha',
       'yanbu', 'hail', 'buraidah', 'najran'],
  QA: ['doha', 'al wakrah', 'wakrah', 'lusail', 'al rayyan', 'rayyan', 'mesaieed'],
  OM: ['muscat', 'salalah', 'sohar', 'nizwa', 'sur', 'ibri', 'seeb', 'muttrah', 'duqm'],
  KW: ['kuwait city', 'hawalli', 'salmiya', 'farwaniya', 'jahra', 'ahmadi', 'fahaheel'],
  BH: ['manama', 'riffa', 'muharraq', 'isa town', 'hamad town', 'sitra'],
  YE: ['sanaa', "sana'a", 'aden', 'taiz', 'hodeidah', 'mukalla'],
  IQ: ['baghdad', 'basra', 'basrah', 'erbil', 'irbil', 'mosul', 'najaf', 'karbala', 'sulaymaniyah'],
  IR: ['persia', 'tehran', 'mashhad', 'isfahan', 'shiraz', 'tabriz'],
  JO: ['amman', 'aqaba', 'irbid', 'zarqa'],
  LB: ['beirut', 'tripoli', 'sidon'],
  SY: ['damascus', 'aleppo', 'homs', 'latakia'],
  EG: ['cairo', 'alexandria', 'giza', 'sharm el sheikh', 'hurghada', 'luxor'],
  PS: ['gaza', 'ramallah', 'west bank', 'jerusalem'],
  IN: ['bharat', 'mumbai', 'bombay', 'delhi', 'new delhi', 'bangalore', 'bengaluru',
       'hyderabad', 'chennai', 'kolkata', 'pune', 'ahmedabad', 'surat', 'jaipur',
       'lucknow', 'nagpur', 'thane', 'navi mumbai', 'noida', 'gurgaon', 'gurugram', 'kochi'],
  PK: ['karachi', 'lahore', 'islamabad', 'rawalpindi', 'peshawar'],
  GB: ['uk', 'britain', 'great britain', 'england', 'scotland', 'wales',
       'northern ireland', 'london', 'manchester', 'birmingham', 'glasgow', 'leeds'],
  US: ['usa', 'america', 'united states of america', 'new york', 'nyc', 'los angeles',
       'chicago', 'houston', 'dallas', 'miami', 'san francisco', 'texas', 'california'],
  CA: ['toronto', 'vancouver', 'montreal', 'calgary', 'ottawa'],
  AU: ['sydney', 'melbourne', 'brisbane', 'perth', 'canberra'],
  SG: ['singapore city'],
  MY: ['kuala lumpur', 'kl', 'penang', 'johor'],
  TH: ['bangkok', 'phuket', 'siam'],
  TR: ['turkiye', 'istanbul', 'ankara', 'antalya'],
  NL: ['holland', 'amsterdam', 'rotterdam'],
  DE: ['deutschland', 'berlin', 'munich', 'frankfurt', 'hamburg'],
  FR: ['paris', 'marseille', 'lyon', 'nice'],
  ES: ['madrid', 'barcelona', 'valencia'],
  IT: ['rome', 'milan', 'naples', 'venice'],
  CH: ['zurich', 'geneva', 'bern'],
  RU: ['moscow', 'saint petersburg', 'russian federation'],
  CN: ['beijing', 'shanghai', 'shenzhen', 'guangzhou'],
  JP: ['tokyo', 'osaka', 'kyoto'],
  KR: ['korea', 'seoul', 'busan'],
  KP: ['korea'],
  HK: ['hong kong sar'],
  ID: ['jakarta', 'bali', 'surabaya'],
  PH: ['manila', 'cebu', 'davao'],
  BD: ['dhaka', 'chittagong'],
  LK: ['ceylon', 'colombo'],
  NP: ['kathmandu'],
  ZA: ['johannesburg', 'cape town', 'durban', 'pretoria'],
  NG: ['lagos', 'abuja'],
  KE: ['nairobi', 'mombasa'],
  MA: ['casablanca', 'rabat', 'marrakech'],
  BR: ['sao paulo', 'rio de janeiro', 'brasilia'],
  MX: ['mexico city', 'cancun', 'guadalajara'],
  NZ: ['auckland', 'wellington'],
  IE: ['dublin', 'eire'],
  MM: ['burma', 'yangon'],
  CZ: ['czech republic', 'prague'],
  CI: ['ivory coast', 'abidjan'],
  SZ: ['swaziland'],
  MK: ['macedonia'],
  CD: ['drc', 'zaire', 'kinshasa'],
  TL: ['east timor'],
  CV: ['cabo verde'],
  VA: ['holy see'],
};

// Shown first — the markets this CRM is actually used in.
const PINNED = ['IN', 'AE', 'QA', 'SA', 'OM', 'KW', 'BH', 'US', 'GB'];

const flagOf = (iso2) =>
  iso2.replace(/./g, (ch) => String.fromCodePoint(127397 + ch.charCodeAt(0)));

const byName = (a, b) => a[1].localeCompare(b[1]);
const pinned = PINNED.map((iso) => RAW.find((r) => r[0] === iso)).filter(Boolean);
const rest = RAW.filter((r) => !PINNED.includes(r[0])).sort(byName);

/** Full list: { iso2, name, dial, flag, label, keywords } */
export const COUNTRIES = [...pinned, ...rest].map(([iso2, name, dial]) => ({
  iso2,
  name,
  dial,
  flag: flagOf(iso2),
  label: `${flagOf(iso2)} ${dial}`,
  // everything a user might type to find this country
  keywords: [name, iso2, dial, dial.replace('+', ''), ...(ALIASES[iso2] || [])]
    .join(' ')
    .toLowerCase(),
}));

// Several countries share a dial code (+1 US/CA, +7 RU/KZ). A <select> stores
// only the dial code, so keep one option per distinct code — otherwise the list
// shows the same number twice. For a shared code, show the country users expect.
const PRIMARY_FOR_DIAL = { '+1': 'US', '+7': 'RU' };

const seen = new Set();
const UNIQUE = COUNTRIES.filter((c) => {
  if (seen.has(c.dial)) return false;
  const primary = PRIMARY_FOR_DIAL[c.dial];
  if (primary && primary !== c.iso2) return false; // wait for the primary country
  seen.add(c.dial);
  return true;
});

/** For <FormSelect options={...} /> — { value, label } */
export const COUNTRY_CODE_OPTIONS = UNIQUE.map((c) => ({
  value: c.dial,
  label: c.label,
  title: `${c.name} (${c.dial})`,
}));

export const DEFAULT_COUNTRY_CODE = '+91';

/**
 * Valid national (subscriber) number lengths per dial code — the digits typed
 * after the country code. Several countries legitimately allow more than one
 * length, so each entry is a list; a dial code that is not listed falls back to
 * a permissive 7–15, which is what every form used to apply unconditionally.
 */
export const NATIONAL_LENGTHS = {
  // Gulf
  '+971': [9], '+966': [9], '+968': [8], '+974': [8], '+965': [8], '+973': [8],
  '+967': [9], '+964': [10], '+962': [9], '+961': [7, 8], '+963': [9], '+970': [9],
  // South Asia
  '+91': [10], '+92': [10], '+880': [10], '+977': [10], '+94': [9], '+960': [7],
  // Rest of the common markets
  '+1': [10], '+44': [10], '+20': [10], '+98': [10], '+90': [10], '+7': [10],
  '+60': [9, 10], '+65': [8], '+66': [9], '+63': [10], '+62': [9, 10, 11, 12],
  '+61': [9], '+64': [8, 9], '+27': [9], '+234': [10], '+254': [9], '+212': [9],
  '+49': [10, 11], '+33': [9], '+39': [9, 10], '+34': [9], '+31': [9], '+41': [9],
  '+86': [11], '+81': [10], '+82': [9, 10], '+852': [8], '+55': [10, 11], '+52': [10],
};

const FALLBACK_LENGTHS = { min: 7, max: 15 };

/** True when `digits` is a plausible national number for that dial code. */
export const isValidNationalNumber = (dial, digits) => {
  const n = String(digits || '').replace(/\D/g, '').length;
  const allowed = NATIONAL_LENGTHS[dial];
  if (allowed) return allowed.includes(n);
  return n >= FALLBACK_LENGTHS.min && n <= FALLBACK_LENGTHS.max;
};

/** Longest number the field should accept — drives the input's maxLength. */
export const maxNationalLength = (dial) => {
  const allowed = NATIONAL_LENGTHS[dial];
  return allowed ? Math.max(...allowed) : FALLBACK_LENGTHS.max;
};

/** '9', '7/8' or '7-15' — used in the validation message. */
export const nationalLengthHint = (dial) => {
  const allowed = NATIONAL_LENGTHS[dial];
  return allowed ? allowed.join('/') : `${FALLBACK_LENGTHS.min}-${FALLBACK_LENGTHS.max}`;
};

// Dial codes longest-first, so '+9714…' matches '+971' before '+9'.
const DIALS_BY_LENGTH = Object.keys(NATIONAL_LENGTHS).sort((a, b) => b.length - a.length);

/**
 * Some forms (quick-add lead, loan applicant) keep the whole number in one
 * field — "+91 98765 43210". Pull the dial code off the front so those can be
 * validated per country too. Returns { dial: null } when no code was typed.
 */
export const splitPhoneNumber = (raw) => {
  const compact = String(raw || '').replace(/[^\d+]/g, '');
  if (compact.startsWith('+')) {
    const dial = DIALS_BY_LENGTH.find((d) => compact.startsWith(d));
    if (dial) return { dial, national: compact.slice(dial.length) };
  }
  return { dial: null, national: compact.replace(/\D/g, '') };
};

/**
 * Validate a combined "code + number" string. Without a recognised dial code it
 * falls back to the permissive 7–15 rule, so a plain local number still passes.
 */
export const isValidPhoneString = (raw) => {
  const { dial, national } = splitPhoneNumber(raw);
  return isValidNationalNumber(dial, national);
};

/** Message hint for a combined string, e.g. "9" for a +971 number. */
export const phoneStringHint = (raw) => nationalLengthHint(splitPhoneNumber(raw).dial);

export default COUNTRY_CODE_OPTIONS;
